export default {"src":"/_next/static/media/bluedot-logo-w.14d257e1.svg","height":36,"width":229};